"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserAgent = void 0;
const tslib_1 = require("tslib");
const ua_parser_js_1 = tslib_1.__importDefault(require("ua-parser-js"));
const getUserAgent = () => (0, ua_parser_js_1.default)(window.navigator.userAgent);
exports.getUserAgent = getUserAgent;
//# sourceMappingURL=user-agent.js.map